import CompanyRegistration from './container/CompanyRegistration';

export default CompanyRegistration;



// WEBPACK FOOTER //
// ./src/views/CompanyRegistration/index.js